import { Component, defineComponent } from '@decify/cell-shopify/client';
export const triggerName = 'Trigger';
export const triggerTagName = 'cell-component-trigger';
export const triggerExpandEvent = 'expand';
export class Trigger extends Component {
    constructor() {
        super(triggerName);
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        this.addEventListener('click', this.handleClick);
    }
    handleClick() {
        this.expanded = !this.expanded;
        this.controlledElement.hidden = !this.expanded;
    }
    get expanded() {
        return this.getAttribute('aria-expanded') === 'true';
    }
    set expanded(value) {
        this.setAttribute('aria-expanded', value.toString());
    }
    get controlledElementId() {
        const controlledElementId = this.getAttribute('aria-controls');
        if (!controlledElementId) {
            throw new Error('Trigger must have an aria-controls attribute');
        }
        return controlledElementId;
    }
    get controlledElement() {
        const controlledElement = document.getElementById(this.controlledElementId);
        if (!controlledElement) {
            throw new Error(`Could not find element with id ${this.controlledElementId}`);
        }
        return controlledElement;
    }
}
defineComponent(triggerTagName, Trigger);
